import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import { ReactComponent as Success } from "../../svgs/success.svg";

const RequestConfirmed = ({ open, onCancel }) => {
  return (
    <DiaglogBox width={400} onCancel={onCancel} open={open}>
      <div
        className="py-5"
        style={{
          background: "url('/images/green_wave_bg.svg')",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="w-16 h-16 bg-[#5CD100] rounded-full mx-auto flex justify-center items-center">
          <Success className="text-white w-[50px] h-[50px]" />
        </div>
      </div>
      <h3 className="text-center text-xl px-11 font-bold">
        Transfer request Initiated !
      </h3>

      <p className="text-[10px] mt-2.5 font-light px-7 text-center">
        Your transfer request for the project has been initiated. it might take
        up to Seven days. You will be notified after the transfer !
      </p>

      <div className="pb-5">
        <Button
          color={"blue"}
          className={
            "w-[120px] mt-[26px] h-[40px] text-white text-sm font-bold mx-auto block"
          }
          varient={"primary"}
          onClick = {onCancel}
        >
          Go back
        </Button>
      </div>
    </DiaglogBox>
  );
};

export default RequestConfirmed;
